export { default as weChatPayService } from './wechatpay-service'
